import { gql } from '@apollo/client';

export const GET_LEAGUE_MESSAGES = gql`
  query GetLeagueMessages($fantasyLeagueId: ID!, $limit: Int, $offset: Int) {
    leagueMessages(
      fantasyLeagueId: $fantasyLeagueId
      limit: $limit
      offset: $offset
    ) {
      id
      text
      createdAt
      user {
        id
        fullName
        picture
        updatedAt
      }
    }
  }
`;
